/*
 * Copy-to-clipboard for [data-discount-code] spans from snippets/custom-text.liquid.
 * Click/tap target is the span's grandparent (e.g. the heading block wrapper).
 */

(function () {
  const FEEDBACK_MS = 1000;
  const COPIED_MESSAGE = 'Discount copied to clipboard';

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    } finally {
      document.body.removeChild(textarea);
    }
  }

  function getClickTarget(span) {
    const parent = span.parentElement;
    return parent && parent.parentElement ? parent.parentElement : parent || span;
  }

  function showFeedback(target, message) {
    let feedback = target.querySelector('[data-discount-code-feedback]');
    if (!feedback) {
      feedback = document.createElement('span');
      feedback.className = 'custom-text-discount-code__feedback';
      feedback.setAttribute('data-discount-code-feedback', '');
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      target.appendChild(feedback);
    }

    feedback.textContent = message;
    feedback.hidden = false;
    target.classList.add('custom-text-discount-code--copied');

    if (target._discountCodeFeedbackTimer) {
      clearTimeout(target._discountCodeFeedbackTimer);
    }

    target._discountCodeFeedbackTimer = setTimeout(() => {
      feedback.hidden = true;
      feedback.textContent = '';
      target.classList.remove('custom-text-discount-code--copied');
    }, FEEDBACK_MS);
  }

  function bindDiscountCode(span) {
    const code = (span.textContent || '').trim();
    if (!code) return;

    const target = getClickTarget(span);
    if (!target || target.dataset.discountCodeCopyBound === 'true') return;

    target.dataset.discountCodeCopyBound = 'true';
    target.classList.add('custom-text-discount-code__target');

    target.addEventListener('click', () => {
      const currentCode = (span.textContent || '').trim();
      if (!currentCode) return;

      copyText(currentCode)
        .then(() => showFeedback(target, COPIED_MESSAGE))
        .catch(() => showFeedback(target, 'Unable to copy discount code'));
    });
  }

  function init() {
    document.querySelectorAll('[data-discount-code]').forEach((span) => {
      // Inside the Issue Quiz Bundle the code is applied silently to the cart
      // on CTA click, so skip the copy-to-clipboard + feedback message here.
      if (span.closest('issue-quiz-bundle')) return;
      bindDiscountCode(span);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
